/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { WebhookAnalyticsResponse } from '../models';
/**
 * WebhookAnalyticsApi - axios parameter creator
 * @export
 */
export const WebhookAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve comprehensive webhook delivery analytics and metrics for the authenticated partner. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get webhook delivery analytics for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {GetPartnerWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhookAnalytics: async (partnerId: string, period?: GetPartnerWebhookAnalyticsPeriodEnum, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerWebhookAnalytics', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/analytics`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed analytics and metrics for a specific webhook configuration. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get analytics for specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {GetWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookAnalytics: async (partnerId: string, webhookId: string, period?: GetWebhookAnalyticsPeriodEnum, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getWebhookAnalytics', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('getWebhookAnalytics', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/analytics`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookAnalyticsApi - functional programming interface
 * @export
 */
export const WebhookAnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookAnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve comprehensive webhook delivery analytics and metrics for the authenticated partner. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get webhook delivery analytics for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {GetPartnerWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerWebhookAnalytics(partnerId: string, period?: GetPartnerWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerWebhookAnalytics(partnerId, period, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookAnalyticsApi.getPartnerWebhookAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed analytics and metrics for a specific webhook configuration. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get analytics for specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {GetWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookAnalytics(partnerId: string, webhookId: string, period?: GetWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookAnalytics(partnerId, webhookId, period, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookAnalyticsApi.getWebhookAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookAnalyticsApi - factory interface
 * @export
 */
export const WebhookAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookAnalyticsApiFp(configuration)
    return {
        /**
         * Retrieve comprehensive webhook delivery analytics and metrics for the authenticated partner. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get webhook delivery analytics for partner
         * @param {string} partnerId Partner ID (ULID)
         * @param {GetPartnerWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhookAnalytics(partnerId: string, period?: GetPartnerWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookAnalyticsResponse> {
            return localVarFp.getPartnerWebhookAnalytics(partnerId, period, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed analytics and metrics for a specific webhook configuration. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
         * @summary Get analytics for specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {GetWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
         * @param {string} [from] Start date for custom period (ISO 8601 format)
         * @param {string} [to] End date for custom period (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookAnalytics(partnerId: string, webhookId: string, period?: GetWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookAnalyticsResponse> {
            return localVarFp.getWebhookAnalytics(partnerId, webhookId, period, from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookAnalyticsApi - object-oriented interface
 * @export
 * @class WebhookAnalyticsApi
 * @extends {BaseAPI}
 */
export class WebhookAnalyticsApi extends BaseAPI {
    /**
     * Retrieve comprehensive webhook delivery analytics and metrics for the authenticated partner. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
     * @summary Get webhook delivery analytics for partner
     * @param {string} partnerId Partner ID (ULID)
     * @param {GetPartnerWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
     * @param {string} [from] Start date for custom period (ISO 8601 format)
     * @param {string} [to] End date for custom period (ISO 8601 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAnalyticsApi
     */
    public getPartnerWebhookAnalytics(partnerId: string, period?: GetPartnerWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return WebhookAnalyticsApiFp(this.configuration).getPartnerWebhookAnalytics(partnerId, period, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed analytics and metrics for a specific webhook configuration. Includes success rates, response times, failure patterns, and volume trends with time-based filtering support.
     * @summary Get analytics for specific webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {GetWebhookAnalyticsPeriodEnum} [period] Time period for analytics data
     * @param {string} [from] Start date for custom period (ISO 8601 format)
     * @param {string} [to] End date for custom period (ISO 8601 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAnalyticsApi
     */
    public getWebhookAnalytics(partnerId: string, webhookId: string, period?: GetWebhookAnalyticsPeriodEnum, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return WebhookAnalyticsApiFp(this.configuration).getWebhookAnalytics(partnerId, webhookId, period, from, to, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPartnerWebhookAnalyticsPeriodEnum = {
    Last24Hours: 'last24Hours',
    Last7Days: 'last7Days',
    Last30Days: 'last30Days',
    Custom: 'custom'
} as const;
export type GetPartnerWebhookAnalyticsPeriodEnum = typeof GetPartnerWebhookAnalyticsPeriodEnum[keyof typeof GetPartnerWebhookAnalyticsPeriodEnum];
/**
 * @export
 */
export const GetWebhookAnalyticsPeriodEnum = {
    Last24Hours: 'last24Hours',
    Last7Days: 'last7Days',
    Last30Days: 'last30Days',
    Custom: 'custom'
} as const;
export type GetWebhookAnalyticsPeriodEnum = typeof GetWebhookAnalyticsPeriodEnum[keyof typeof GetWebhookAnalyticsPeriodEnum];
